import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import NotAloneSection from './components/NotAloneSection';
import WarningSignsSection from './components/WarningSignsSection';
import ProcessSection from './components/ProcessSection';
import WhatYouReceiveSection from './components/WhatYouReceiveSection';
import PrivacySection from './components/PrivacySection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <NotAloneSection />
        <WarningSignsSection />
        <ProcessSection />
        <WhatYouReceiveSection />
        <PrivacySection />
      </main>
      <Footer />
    </div>
  );
}
